import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { WaypointsMapContainer } from './quote.component.styles'
import { MemoMap } from './map/map.component'
import { EstimationForm } from './estimation-form/estimation-form.component'
import { VehicleListWithRef } from './vehicle-list/vehicle-list.component'
import { apiService } from './api/api.service'
import { displayAlert } from '../component-library/components/alerts/alerts.component'
import { quoteTrackingService } from './tracking.service'
import { getCountry } from '../service/country.service'

const Quote = () => {
  const [t] = useTranslation()
  const [pickup, setPickup] = useState(null)
  const [dropoff, setDropoff] = useState(null)
  const [estimations, setEstimations] = useState({})
  const [quoteInProgress, setQuoteInProgress] = useState(false)
  const vehicleListRef = React.useRef(null)
  const country = getCountry()

  useEffect(() => {
    const hasEstimation = Object.keys(estimations).length > 0
    if (hasEstimation) {
      handleTrackingAddressesEstimationsVehicles('estimate_price')
    }
  }, [estimations])

  const handleTrackingAddressesEstimationsVehicles = (eventName) => {
    quoteTrackingService.trackAddressesEstimationsVehicles({
      eventName,
      pickupAddress: pickup?.address,
      destinationAddress: dropoff?.address,
      estimationsVehicles: estimations
    })
  }

  const handleClick = async () => {
    if (pickup === null || dropoff === null) {
      return
    }

    try {
      setQuoteInProgress(true)
      const { orders } = await apiService.getEstimation([
        {
          address: pickup.address,
          latitude: pickup.latitude.toString(),
          longitude: pickup.longitude.toString(),
        },
        {
          address: dropoff.address,
          latitude: dropoff.latitude.toString(),
          longitude: dropoff.longitude.toString(),
        }
      ])

      let courierEstimation

      if (country === 'HK') {
        courierEstimation = await apiService.getCourierEstimation({
          shipperLatitude: pickup.latitude.toString(),
          shipperLongitude: pickup.longitude.toString(),
          recipientLongitude: dropoff.longitude.toString(),
          recipientLatitude: dropoff.latitude.toString(),
        })
      }

      const vehicleFeeObject = orders
        .reduce((accumulator, { details, payment }) => {
          const vehicleFee = {
            ...accumulator,
            [details.vehicle_type]: Math.abs(payment.total)
          }
          if (country === 'HK') {
            vehicleFee['courier'] = Math.abs(courierEstimation.payment.total)
          }
          return vehicleFee
        }, {})

      vehicleListRef.current.scrollIntoView({ behavior: "smooth" })
      setEstimations(vehicleFeeObject)
    } catch (error) {
      document.querySelector('#waypointsMapContainer').scrollIntoView({ behavior: "smooth" })
      setEstimations({})
      displayAlert({ message: t('snackbar__something_went_wrong_please_try_again'), autoClose: true, type: 'error' })
    } finally {
      setQuoteInProgress(false)
    }
  }

  const setPickupAndEstimation = value => {
    if (value === null) {
      setEstimations({})
    }
    setPickup(value)
  }

  const setDropoffAndEstimation = value => {
    if (value === null) {
      setEstimations({})
    }
    setDropoff(value)
  }

  return (
    <div>
      <WaypointsMapContainer id="waypointsMapContainer">
        <EstimationForm
          setPickup={setPickupAndEstimation}
          setDropoff={setDropoffAndEstimation}
          onClick={handleClick}
          trackAddressesEstimationsVehicles={handleTrackingAddressesEstimationsVehicles}
        />
        <MemoMap
          pickupCoordinate={pickup}
          dropoffCoordinate={dropoff}
        />
      </WaypointsMapContainer>
      <VehicleListWithRef
        estimations={estimations}
        ref={vehicleListRef}
        trackAddressesEstimationsVehicles={handleTrackingAddressesEstimationsVehicles}
        quoteInProgress={quoteInProgress}
      />
    </div>
  )
}

export { Quote }
